var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scroll-pane',{ref:"scrollPane",staticClass:"tags-view-container"},_vm._l((Array.from(_vm.visitedViews)),function(tag){return _c('router-link',{key:tag.path,ref:"tag",refInFor:true,staticClass:"tags-view-item",class:_vm.isActive(tag)?'active':'',attrs:{"to":tag.path}},[_vm._v("\n    "+_vm._s(tag.title)+"\n    "),_c('span',{staticClass:"el-icon-close",on:{"click":function($event){_vm.closeViewTags(tag,$event)}}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7c79028","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/TagsView.vue
// module id = WEPF
// module chunks = 28